import React from 'react';

import './styles.css';
import {Grid} from "@material-ui/core";

const version = "0.0.1";

function Landing() {


    return (
        <div id="page-landing">
            <div id="page-landing-content" className="container">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                        <div className="logo-container">
                            <img src='https://idxasdyjtohttzhbdmnq.supabase.co/storage/v1/object/public/imgs//logo.jpg' alt="Logo" className="logo" />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <img
                            src='https://idxasdyjtohttzhbdmnq.supabase.co/storage/v1/object/public/imgs//apoio.jpg'
                            alt="Plataforma de avaliação"
                            className="hero-image"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <small className="version">Versão: {version}</small>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default Landing;
